import React from 'react'
import { LntBadge } from '@app/components/base'

import variables from '@app/theme/variables'
import { isNullable } from '@app/utils'

import { MONITORING_MATCHING_STATUS } from '@app/api/constants'

import type { ObjectValuesType } from '@app/types'

export const BadgeDotRender: React.FC<{ status?: ObjectValuesType<typeof MONITORING_MATCHING_STATUS> | null }> = ({
  status
}) => {
  if (isNullable(status)) return null
  const color = status === 'matched' ? variables.successGreen : variables.dangerRed

  return <LntBadge color={ color } />
}
